export const heading = {
  sizes: {
    h1: {
      fontSize: "42px",
      fontWeight: "bold",
      lineHeight: "110%"
    },
    h2: {
      fontSize: "32px",
      fontWeight: "semibold",
      lineHeight: "110%"
    },
    h3: {
      fontSize: "26px",
      fontWeight: "semibold",
      lineHeight: "110%"
    },
    h4: {
      fontSize: "18px",
      fontWeight: "semibold",
      lineHeight: "110%"
    },
    h5: {
      fontSize: "14px",
      fontWeight: "semibold",
      lineHeight: "110%"
    },
    h6: {
      fontSize: "10px",
      fontWeight: "semibold",
      lineHeight: "110%"
    }
  }
}
